import { DateFormat, t, Trans } from '@lingui/macro'
import React from 'react'
import styled from 'react-emotion/macro'
import { EBillingPlan, IAccount } from 'shopify-payment-core'

import { billingPlanLabels } from '../atoms/AccountBillingPlan'
import { Brick } from '../atoms/Brick'
import { InfoLine } from '../atoms/InfoLine'
import { i18n } from '../i18n'
import { AccountDeleteButton } from '../molecules/AccountDeleteButton'

interface IProps {
  account: IAccount
}

const FloatRight = styled.div`
  float: right;
  margin-bottom: 1rem;
`

export const AccountClientInfo: React.FC<IProps> = ({ account }) => {
  return (
    <Brick admin={false} title={<Trans>Základní informace o účtu</Trans>}>
      {account.billingPlan && (
        <InfoLine label={i18n._(t`Platební plán`)}>
          {i18n._(billingPlanLabels[account.billingPlan])}
        </InfoLine>
      )}
      {account.invoiceDueDate && account.billingPlan === EBillingPlan.MONTHLY && (
        <InfoLine label={i18n._(t`Splatnost faktury`)}>
          <DateFormat value={new Date(account.invoiceDueDate)} />
        </InfoLine>
      )}
      {account.invoicePaidAt && account.billingPlan === EBillingPlan.ONETIME && (
        <InfoLine label={i18n._(t`Zaplaceno`)}>
          <DateFormat value={new Date(account.invoicePaidAt)} />
        </InfoLine>
      )}
      <InfoLine label={i18n._(t`Kontaktní email`)}>
        {account.contactEmail}
      </InfoLine>
      <InfoLine label={i18n._(t`Registrováno od`)}>
        <DateFormat value={new Date(account.createdAt)} />
      </InfoLine>
      <br />
      <FloatRight>
        <AccountDeleteButton account={account} />
      </FloatRight>
    </Brick>
  )
}
